import { createContext } from 'react';

export const OffsetLayoutContext = createContext<OffsetLayout>({
    xs: 1,
    sm: 1,
    md: 1,
    lg: 2,
    xl: 2,
    xxl: 2
});